export default __webpack_public_path__ + "static/media/DtVnJx26TKEr37c9aBBx_kwfzg38pQhMruE-f1.425c8855.woff2";